import Field from '@/components/common/Field/Field';
import * as S from './style';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { ContainerInput } from '@/components/common/Input/InputText/style';
import { useGetMemberEtcInfoApi, usePostModifyMemberEtcInfoApi } from '@/api/mypage';
import { useToastStore } from '@/store/toastStore';
interface RegisterField {
	topic: string;
	spot: string;
}
const EtcInfo = () => {
	const { openToast } = useToastStore();

	const userRegisterSchema = z.object({
		topic: z.string(),
		spot: z.string().min(1, '이름을 입력해 주세요'),
	});

	const { register, handleSubmit, setValue } = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		mode: 'onChange',
		defaultValues: { topic: '', spot: '자택' }, // 초기값을 배열로 설정
	});

	const { data: etcInfo } = useGetMemberEtcInfoApi();
	const { mutateAsync: modifyEtcInfo } = usePostModifyMemberEtcInfoApi();

	useEffect(() => {
		if (etcInfo) {
			setValue('topic', etcInfo.member_research_topic);
			setValue('spot', etcInfo.member_receive_post);
		}
	}, [etcInfo]);

	const onSubmit = async (data: RegisterField) => {
		const res = await modifyEtcInfo({
			member_research_topic: data.topic,
			member_receive_post: data.spot,
		});
		if (res.data.success) {
			openToast({
				subContent: '한국노화학회',
				content: '정보가 변경되었습니다.',
			});
		}
	};

	return (
		<S.FormContainer onSubmit={handleSubmit(onSubmit)}>
			<S.Container>
				<S.FormBox>
					<S.Title>기타정보</S.Title>
					<Field title="연구주제(관심분야)">
						<ContainerInput type="text" {...register('topic')} />
					</Field>

					<Field title="우편물 수령 장소 선택" gap="0.8rem">
						<S.SpotExplain>※ 한국노화학회에서 보내는 우편물(학회지 및 논문집)을 선택하신 곳으로 받아 보실 수 있습니다.</S.SpotExplain>

						<S.GenderBox>
							<S.GenderRadio>
								<label>
									<input type="radio" value="자택" {...register('spot')} />
									자택
								</label>
							</S.GenderRadio>
							<S.GenderRadio>
								<label>
									<input type="radio" value="직장" {...register('spot')} />
									직장
								</label>
							</S.GenderRadio>
						</S.GenderBox>
					</Field>
				</S.FormBox>
				<S.NextButton type="submit">변경 완료</S.NextButton>
			</S.Container>
		</S.FormContainer>
	);
};
export default EtcInfo;
